module.exports = __webpack_public_path__ + "img/vs-selfpetition.1d099a90.svg";